import { getMapLayerOpacity } from "./getMapLayerOpacity";

export default getMapLayerOpacity;
